export const RCD_FEE_TD = "75";
export const RCD_FEE_GD = "75";
export const RCD_FEE_GD_TR = "75";
